import request from '@/shared/api/request';

export const deleteStacklet = (id: number): Promise<void> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'DELETE',
  });
